"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Organization {
    constructor({ id, name, createdAt }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            createdAt: this.createdAt,
        });
        this.id = id;
        this.name = name;
        this.createdAt = createdAt;
    }
}
Organization.fromJSON = (json) => {
    const { id, name, createdAt } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (typeof createdAt !== 'string' && typeof createdAt !== 'undefined')
        throw new Error('.createdAt must be a string');
    return new Organization({
        id,
        name,
        createdAt,
    });
};
exports.default = Organization;
